// https://colornamer.robertcooper.me/

export const STYLE_TOKENS = {
    COLORS: {
        colWhite: "#FFFFFF",
        colRaven: "#0B0B0B",
        colIron: "#5D5E5E",
        colBeluga: "#F0F2F2",
        colToryRed: "#D76C61",
        colStrawberryRose: "#E39890",
        colIvoryTower: "#fbf0ef",
        colRaceCarStripe: "#CD4942",
        colDoubleClick: "#CFD1D1",
        colIceBlue: "#709BCD",
        colCarbonFiber: "#2D2D2D",
    },
    BORDERS: {
        RADIUS: {
            FIELD: {
                default: "4px",
            },
        },
    },
};
